const initialState = { 
  loading: false,
  payload: null,
  error: null
}

function getDashboardReducer(state = initialState, action) {
  switch (action.type) {
    case 'GET_DASHBOARD_BEGIN':
      return {
        ...state,
        loading: true,
        error: null
      }

    case 'GET_DASHBOARD_SUCCESS':
      return {
        ...state,
        loading: false,
        payload: action.payload
      }

    case 'GET_DASHBOARD_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default getDashboardReducer